<template>
  <div class="flex items-center h-full overflow-hidden" :title="fullLabels">
    <span v-if="!permissions.length">-</span>
    <vs-chip v-for="permission in permissions" :key="permission" class="permission-chip" color="primary">
      {{ shortLabels[permission] || permission }}
    </vs-chip>
  </div>
</template>

<script>
import Vue from "vue";
import { SUPERVISOR_PERMISSION_LABELS, SUPERVISOR_PERMISSION_SHORT_LABELS } from "../models";

export default Vue.extend({
  name: "SupervisorPermissionsCell",
  data() {
    return {
      shortLabels: SUPERVISOR_PERMISSION_SHORT_LABELS,
    };
  },
  computed: {
    permissions() {
      return this.params.value || [];
    },
    fullLabels() {
      return this.permissions.map((key) => SUPERVISOR_PERMISSION_LABELS[key] || key).join("، ");
    },
  },
});
</script>

<style scoped>
.permission-chip {
  height: 26px;
  margin: 0 0 0 4px;
  flex-shrink: 0;
}
</style>
